import { render, staticRenderFns } from "./TaxDetail.vue?vue&type=template&id=95e2de3a&"
import script from "./TaxDetail.vue?vue&type=script&lang=js&"
export * from "./TaxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports